/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const edit_ticket = /* GraphQL */ `
  mutation Edit_ticket($input: ticketInputs) {
    edit_ticket(input: $input)
  }
`;
export const add_correspondence = /* GraphQL */ `
  mutation Add_correspondence($input: ticketInputs) {
    add_correspondence(input: $input)
  }
`;
export const edit_correspondence = /* GraphQL */ `
  mutation Edit_correspondence($input: ticketInputs) {
    edit_correspondence(input: $input)
  }
`;
export const get_upload_url = /* GraphQL */ `
  mutation Get_upload_url($input: getUploadUrlInput) {
    get_upload_url(input: $input)
  }
`;
